import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Header from "../header/Header";
import methods from "../../services/utility";
import StepProgress from "../../views/public/stepProgress/StepProgress";
import BaseInfoRestaurantSidebar from "../sidebar/BaseInfoRestaurantSidebar";
import RestaurantHeader from "../header/RestaurantHeader";

const BaseInfoRestaurantLayout = ({ component: Component, ...rest }) => {
  const [collapsed, setCollapsed] = useState(false);
  const isUserLogedin = methods.checkUserLogin();
  return (
    <div className="container-fluid vh-100 min-vh-100">
      {isUserLogedin ? (
        <>
          <RestaurantHeader setCollapsed={setCollapsed} />
          <div className="row bg-light">
            <div className="col-lg-2 border-end border-secondary-subtle bg-white">
              <BaseInfoRestaurantSidebar />
            </div>
            <div className="col-lg-10 p-4 mx-auto">
              {/* <StepProgress /> */}
              <Component {...rest} />
            </div>
          </div>
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </div>
  );
};

export default BaseInfoRestaurantLayout;
